import React, { createContext, useCallback, useContext, useState } from 'react';

const DiagnosticsContext = createContext(null);

export function DiagnosticsProvider({ children }) {
  const [timings, setTimings] = useState({});

  const reportTiming = useCallback((widgetId, timing) => {
    setTimings(prev => ({ ...prev, [widgetId]: timing }));
  }, []);

  return (
    <DiagnosticsContext.Provider value={{ timings, reportTiming }}>
      {children}
    </DiagnosticsContext.Provider>
  );
}

export function useDiagnostics() {
  return useContext(DiagnosticsContext);
}
